var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import styled from 'styled-components';
import { hoverMediaQuery } from '@finect/tabular-utils/mediaQueries';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { getFont } from '@finect/tabular-utils/getFont';
import { Image } from '@finect/tabular-icons/image';
import { Video } from '@finect/tabular-icons/video';
import { Link } from '@finect/tabular-icons/link';
import { Underline } from '@finect/tabular-icons/underline';
import { Bold } from '@finect/tabular-icons/bold';
import { List } from '@finect/tabular-icons/list';
import { Heading } from '@finect/tabular-icons/heading';
import { Heading2 } from '@finect/tabular-icons/heading2';
import { Blockquote } from '@finect/tabular-icons/blockquote';
import { OrderedList } from '@finect/tabular-icons/orderedList';
import { DollarSign } from '@finect/tabular-icons/dollarSign';
import { AtSign } from '@finect/tabular-icons/atSign';
var Label = styled.div.withConfig({
  displayName: "StyleButton__Label",
  componentId: "sc-1cpvkh9-0"
})(["position:absolute;z-index:3;top:0;left:50%;opacity:0;padding:0 9px;border-radius:", ";background-color:", ";", ";white-space:nowrap;color:#fff;transform:translateX(-50%) translateY(-100%) translateY(-6px);"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mainColor;
}, getFont(-1));
var EditorButton = styled.div.withConfig({
  displayName: "StyleButton__EditorButton",
  componentId: "sc-1cpvkh9-1"
})(["position:relative;padding:6px 9px;cursor:pointer;background-color:", ";", ";font-weight:500;", ";color:", ";&:not(:first-child){border-left:1px solid ", ";}&:first-child{border-radius:", ";}&:last-child{border-radius:", ";}&:only-child{border-radius:", ";}", ";svg{position:relative;top:4px;}"], function (_ref3) {
  var active = _ref3.active,
    theme = _ref3.theme;
  return active ? theme.mainColor : '#fff';
}, getFont(0), fontSmoothing, function (_ref4) {
  var active = _ref4.active,
    theme = _ref4.theme;
  return active ? '#fff' : theme.colors.font;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.borderRadius, " 0 0 ").concat(theme.borderRadius);
}, function (_ref7) {
  var theme = _ref7.theme;
  return " 0 ".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 0");
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.borderRadius;
}, hoverMediaQuery(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &:hover {\n      color: ", ";\n\n      ", " {\n        opacity: ", ";\n      }\n    }\n  }"])), function (_ref9) {
  var active = _ref9.active,
    theme = _ref9.theme;
  return active ? '#fff' : theme.mainColor;
}, Label, function (_ref10) {
  var hasTouch = _ref10.hasTouch;
  return hasTouch ? 0 : 1;
}));
export var StyleButton = function StyleButton(_ref11) {
  var active = _ref11.active,
    onToggle = _ref11.onToggle,
    icon = _ref11.icon,
    label = _ref11.label,
    style = _ref11.style;
  var handleClick = function handleClick(event) {
    event.preventDefault();
    onToggle(style);
  };
  var displayIcon = function displayIcon(type) {
    var props = {
      size: '18',
      strokeWidth: '2.2'
    };
    switch (type) {
      case 'image':
        return React.createElement(Image, props);
      case 'video':
        return React.createElement(Video, props);
      case 'link':
        return React.createElement(Link, props);
      case 'underline':
        return React.createElement(Underline, props);
      case 'bold':
        return React.createElement(Bold, props);
      case 'ul':
        return React.createElement(List, props);
      case 'ol':
        return React.createElement(OrderedList, props);
      case 'blockquote':
        return React.createElement(Blockquote, props);
      case 'heading2':
        return React.createElement(Heading2, props);
      case 'heading':
        return React.createElement(Heading, props);
      case 'dollar':
        return React.createElement(DollarSign, props);
      case 'at':
        return React.createElement(AtSign, props);
      default:
        return React.createElement(Link, props);
    }
  };
  var hasTouch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  return React.createElement(EditorButton, {
    onTouchEnd: handleClick,
    onMouseDown: handleClick,
    hasTouch: hasTouch,
    active: active
  }, displayIcon(icon), React.createElement(Label, null, label));
};